import React, { useEffect } from "react";
import jwtInterceoptor from "../../components/shared/jwtInterceptor";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
//import "./styles.css";

const PDFJS = window.pdfjsLib;

export default function PagePDF({org_id, typeee, save=false, handleSavePdf,afterSave, clear=false, handleClear}) {

    const [t, i18n] = useTranslation();

    const [pdf, setPdf] = React.useState("");
    const [width, setWidth] = React.useState(0);
    const [images, setImages] = React.useState([]);
    const [height, setHeight] = React.useState(0);
    const [totalPages, setTotalPages] = React.useState(1);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [pdfRendering, setPdfRendering] = React.useState("");
    const [pageRendering, setPageRendering] = React.useState("");
    const [uploading, setUploading] = React.useState(false);
    const [nbProcessed, setNbProcessed] = React.useState(0);
    const [echecProccess, setEchecProcess] = React.useState(0);
    const [finish, setFinish] = React.useState(false);


    async function showPdf(event) {
        try {
            setPdfRendering(true);
            const file = event.target.files[0];
            const uri = URL.createObjectURL(file);
            console.log(uri)
            var _PDF_DOC = await PDFJS.getDocument({ url: uri });
            setPdf(_PDF_DOC);
            setPdfRendering(false);
            document.getElementById("file-to-upload").value = "";
        } catch (error) {
            alert(error.message);
        }
    }

    function changePage() {
        setCurrentPage();
    }

    async function renderPage() {
        setPageRendering(true);
        const imagesList = [];
        const canvas = document.createElement("canvas");
        canvas.setAttribute("className", "canv");
        let canv = document.querySelector(".canv");

        for (let i = 1; i <= pdf.numPages; i++) {
            var page = await pdf.getPage(i);
            var viewport = page.getViewport({ scale: 4 });
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            var render_context = {
                canvasContext: canvas.getContext("2d"),
                viewport: viewport
            };
            console.log("page lenght", pdf.numPages);
            setWidth(viewport.width);
            setHeight(viewport.height);
            await page.render(render_context).promise;
            let img = canvas.toDataURL("image/png",1.0);
            imagesList.push(img);
        }
        setImages(imagesList);
        setPageRendering(false);
    }

    useEffect(() => {
        pdf && renderPage();
        // eslint-disable-next-line
    }, [pdf, currentPage]);

    const styles = {
        wrapper: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px"
        },
        imageWrapper: {
            // width: "300px",
            // height: "350px",
            border: "1px solid rgba(0,0,0,0.15)",
            borderRadius: "3px",
            boxShadow: "0 2px 5px 0 rgba(0,0,0,0.25)",
            padding: "0"
        }
    };

    function base64toBlob(base64Data, contentType) {
        contentType = contentType || '';
        var sliceSize = 1024;
        var byteCharacters = atob(base64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    }

    const onSave = async () => {
        setUploading(true);
        setFinish(false);
        setNbProcessed(0);
        setEchecProcess(0);
        console.log("typeee", typeee);
        console.log("org_id", org_id);
        console.log("images.length", images.length);

        if(typeee == null || org_id == null){
            setUploading(false);
            setFinish(true);
            handleSavePdf();
            alert("Selection des factures et le type !");
            
            return;
        } else {
            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
            if (typeee !== 'rlv'){

            for (let i=0; i<images.length; i++) {
                let blob = base64toBlob(images[i].replace(/^data:image\/(png|jpeg|jpg);base64,/, ""), 'image/png');
                let dataForm = new FormData();
                dataForm.append("invoice", blob, 'inv-id-'+i+'.jpg');
                dataForm.append("org_id", org_id);
                dataForm.append("type", typeee);

                const res = await jwtInterceoptor.post(
                    "/data/uploadInvoice",
                    dataForm,
                    config
                );
                if(res.status == 200){
                    setNbProcessed(nbProcessed+1);
                    afterSave();
                } else {
                    setEchecProcess(echecProccess+1);
                }
            }
        }
            // Handle Rlv
            if (typeee === 'rlv') {
                for (let i=0; i<images.length; i++) {
                    let blob = base64toBlob(images[i].replace(/^data:image\/(png|jpeg|jpg);base64,/, ""), 'image/png');
                    let dataForm = new FormData();
                    dataForm.append("rlv", blob, 'bank-statement-id-'+i+'.jpg');
                    dataForm.append("org_id", org_id);
                    dataForm.append("type", typeee);

                    const res = await jwtInterceoptor.post(
                        "/data/uploadRlv",
                        dataForm,
                        config
                    );
                    if(res.status == 200){
                        setNbProcessed(nbProcessed+1);
                        afterSave();
                    } else {
                        setEchecProcess(echecProccess+1);
                    }
                }
            }

            setUploading(false);
            setFinish(true);
            handleSavePdf();
        }
    }

    useEffect(() => {
        if(save){
            onSave();
        }
    }, [save]);

    useEffect(() => {
        if(clear){
            setUploading(false);
            setFinish(false);
            setImages([]);
            handleClear();
        }
    }, [clear]);

    return (
        <div className="">
            <input
                type="file"
                id="file-to-upload"
                accept="application/pdf"
                className="form-control form-control-lg"
                onChange={showPdf}
            />
            <div id="pdf-main-container">
                <div id="pdf-loader" hidden={!pdfRendering}>
                    Loading document ...
                </div>
                <div className="d-flex flex-row-reverse" hidden={pdfRendering}>
                    <button type="button" className="mt-1  mb-1 me-3 btn btn-secondary">Total pages<span
                        className="text-secondary ms-2 badge bg-white">{images.length}</span></button>
                </div>
                {
                    finish ? (
                        <>
                            <button type="button" className="mt-1  mb-1 me-3 btn btn-success">
                        Enregistré<span
                        className="text-success ms-2 badge bg-white">{nbProcessed}</span>
                                    </button>
                                    <button type="button" className="mt-1  mb-1 me-3 btn btn-danger">
                                    Non enregistré<span
                                    className="text-danger ms-2 badge bg-white">{echecProccess}</span>
                        </button></>):null
                }
{
    uploading ? (
            <>
                <div class="text-secondary bg-secondary-transparent card"
                >
                    <div class="card-body">
                        <h5 class="card-title text-center">{t("Traitement des fichiers")}</h5></div>
                </div>
                <button type="button" className="mt-1  mb-1 me-3 btn btn-success">
                    Enregistré<span
                                className="text-success ms-2 badge bg-white">{nbProcessed}</span>
                            </button>
                            <button type="button" className="mt-1  mb-1 me-3 btn btn-danger">
                                Non enregistré<span
                                className="text-danger ms-2 badge bg-white">{echecProccess}</span>
                            </button>
                        </>
                    )
                    : (<div id="pdf-contents">
                        <div id="image-convas-row">
                            {/* <canvas id="pdf-canvas" width={width} height={height}></canvas> */}
                            <div style={styles.wrapper}>
                                {images.map((image, idx) => (
                                    <div key={idx} style={styles.imageWrapper}>
                                    <img
                                        id="image-generated"
                                        src={image}
                                        alt="pdfImage"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            margin: "0",
                                            border: "none"
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div id="page-loader" hidden={!pageRendering}>
                        Loading page ...
                    </div>
                </div>)}
            </div>
        </div>
    );
}
